const middleware = {}

middleware['analytics'] = require('../../../middleware/analytics.js')
middleware['analytics'] = middleware['analytics'].default || middleware['analytics']

middleware['redirects'] = require('../../../middleware/redirects.js')
middleware['redirects'] = middleware['redirects'].default || middleware['redirects']

export default middleware
